export default Object.freeze({
  ANY: 'ANY',
  INTEGER: 'INTEGER'
});